import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { Col, Row, Form, Dropdown, DropdownButton } from "react-bootstrap";
import {} from 'react-bootstrap-icons';

import AuthErrorComponent from './AuthErrorComponent';
import AlertErrorComponent from './AlertErrorComponent';
import PackagingDetailsHelpComponent from '../components/PackagingDetailsHelpComponent';

import {
    toFixed
  } from "../js/global";

class PackagingDetailsComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            authError:false,
            apiErrorMessage:'',
            errorMessage:'',
            isLoading:false,
            getUnitsAPI:false
        }
    }

/*
Barcode
*/

    handleOnChangeBarcode = (e) => {
        this.props.handleOnChangeBarcode(e.currentTarget.value);
    }

/*
Packaging (GoodsFormatId)
*/

    getPackagingTitle = (value) => {
        let filter = this.props.unitsData.filter( (unit) => unit.UnitId == parseInt(value) )[0];
        if(filter) {
            return filter.UnitName;
        }
        return "Select Packaging";
    }

    handleOnSelectPackaging = (value) => {
        this.props.handleOnSelectPackaging(value, this.getPackagingTitle(value)); 
    }

    htmlDropDownPackaging = () => {
        return this.props.packagingData.map( (unit, index) => {
            return <Dropdown.Item eventKey={unit.UnitId} key={index}>{unit.UnitName}</Dropdown.Item>
        });
    }

/*
Unit Price
*/

    handleOnChangeUnitPrice = (e) => {
        if(e.currentTarget.value >= 0) { 
            this.props.handleOnChangeUnitPrice(e.currentTarget.value);
        }
    }

/*
Unit Qty
*/

    handleOnChangeUnitQty = (e) => {
        if(e.currentTarget.value >= 0) { 
            this.props.handleOnChangeUnitQty(e.currentTarget.value);
        }
    }

/*
Unit Name
*/

    getUnitNameTitle = (unitId) => {
        let filter = this.props.unitsData.filter( (unit) => unit.UnitId == parseInt(unitId) )[0];
        if(filter) {
            return filter.UnitName;
        }
        return "Select Unit Name";
    }

    handleOnSelectUnitName = (value) => {
        this.props.handleOnSelectUnitName(value, this.getUnitNameTitle(value));
    }

    htmlDropDownUnitName = () => {
        return this.props.packagingData.map( (unit, index) => {
            return <Dropdown.Item eventKey={unit.UnitId} key={index}>{unit.UnitName}</Dropdown.Item>
        })
    }

/******
 MISC
 */

    isError = () => {
        if(this.state.apiErrorMessage || this.state.errorMessage || this.state.authError) {
            return true;
        }
        return false;
    }
    
    render() {
        return (
            <Row>
                <Col xs={12}>
                    {this.state.authError
                    ?
                        <AuthErrorComponent />
                    :
                        this.state.apiErrorMessage
                            ?
                                <div className="mt-4">
                                    <AlertErrorComponent label={this.state.apiErrorMessage} />
                                </div>
                            :
                            <>

                            {this.state.errorMessage &&
                                <div className="mt-4">
                                    <AlertErrorComponent label={this.state.errorMessage} />
                                </div>
                            }

                            <>
                                {this.props.tip &&
                                <Row>
                                    <Col xs={12} className="mb-3">
                                        <PackagingDetailsHelpComponent
                                        placement={"right"}
                                        />
                                    </Col>
                                </Row>
                                }
                                <Row>
                                    {this.props.ui.barcode &&
                                    <Col sm={12} md={3}>
                                        <Form.Group controlId={`formBarcode_${this.props.index}`} className="mb-3">
                                            <Form.Label>Barcode</Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                id={`formBarcode_${this.props.index}`}
                                                value={this.props.barcode}
                                                onChange={ (e) => this.handleOnChangeBarcode(e)}
                                                placeholder="Enter barcode"
                                                className="mt-1"
                                            />
                                        </Form.Group>                                        
                                    </Col>
                                    }
                                    
                                    {this.props.ui.unitPrice &&       
                                    <Col sm={12} md={3}>
                                        <Form.Group controlId={`formUnitPrice_${this.props.index}`} className="mb-3">
                                            <Form.Label>Unit Price</Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                id={`formUnitPrice_${this.props.index}`}
                                                value={this.props.unitPrice != "" ? toFixed(this.props.unitPrice,10) : ""}
                                                onChange={ (e) => this.handleOnChangeUnitPrice(e)}
                                                placeholder={0}
                                                className="mt-1"
                                            />
                                        </Form.Group>                                        
                                    </Col>           
                                    }

                                    {this.props.ui.unitQty &&
                                    <Col sm={12} md={3}>
                                        <Form.Group controlId={`formUnitQuantity_${this.props.index}`} className="mb-3">
                                            <Form.Label>Unit Quantity<sup className="text-warning">*</sup></Form.Label>
                                            <Form.Control 
                                                type="text" 
                                                id={`formUnitQuantity_${this.props.index}`}
                                                value={this.props.goodsFormatNum != "" ? toFixed(this.props.goodsFormatNum,5) : ""}
                                                onChange={ (e) => this.handleOnChangeUnitQty(e)}
                                                placeholder={0}
                                                className="mt-1"
                                            />
                                        </Form.Group>                                        
                                    </Col>
                                    }

                                    {this.props.ui.unitName &&
                                    <Col sm={12} md={3}>
                                        <Form.Group controlId={`formUnitName_${this.props.index}`} className="mb-3">
                                            <Form.Label>Unit Name</Form.Label>
                                            <DropdownButton 
                                                id={`formUnitName_${this.props.index}`}
                                                title={this.getUnitNameTitle(this.props.unitId)}
                                                onSelect={this.handleOnSelectUnitName}
                                                value={this.props.unitId}
                                                className="mt-1 child-w-100"
                                                variant="secondary"
                                            >
                                            {this.htmlDropDownUnitName()}
                                            </DropdownButton>
                                        </Form.Group>
                                    </Col>
                                    }
                                    {this.props.ui.unitPacking &&
                                    <Col sm={12} md={3}>
                                        <Form.Group controlId={`formPackaging_${this.props.index}`} className="mb-3">
                                            <Form.Label>Packaging<sup className="text-warning">*</sup></Form.Label>
                                            <DropdownButton 
                                                id={`formPackaging_${this.props.index}`}
                                                title={this.getPackagingTitle(this.props.unitId)}
                                                onSelect={this.handleOnSelectPackaging}
                                                value={this.props.unitId}
                                                className="mt-1 child-w-100"
                                                variant="secondary"
                                            >
                                            {this.htmlDropDownPackaging()}
                                            </DropdownButton>
                                        </Form.Group>
                                    </Col>
                                    }
                                </Row>
                            </>
                            
                        </>   
                    }
                </Col>
            </Row>
        )
    }

}

const mapStateToProps = state => {
    const {auth} = state;
    return { auth: auth };
};

export default connect(mapStateToProps, null)(withRouter(PackagingDetailsComponent));